<template>
  <Modal
    :show="show.deleteApprovalStage"
    width="small"
    @close="close"
  >
    <template #title>
      Delete this approval stage?
    </template>

    <template #content>
      This stage and its slots will be deleted.
    </template>

    <template #actions>
      <v-spacer />

      <v-btn
        variant="flat"
        color="error"
        size="small"
        rounded="lg"
        class="text-button-2"
        @click="confirm"
      >
        Delete
      </v-btn>
    </template>
  </Modal>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useModals } from '@/stores/modals/modals';
import Modal from '@/components/shared/Modal.vue';

defineOptions({ name: 'TemplateStageDeleteModal' });

const emit = defineEmits(['delete']);

const { show } = storeToRefs(useModals());
const { setModal } = useModals();

const close = () => setModal({ field: 'deleteApprovalStage', value: false });

const confirm = () => {
  emit('delete');
  close();
};
</script>
